// extracted by mini-css-extract-plugin
export default {"backBtnWrapper":"BackButton_backBtnWrapper__BdAAE","backButton":"BackButton_backButton__Cc3YS"};